export const rugbyBundesligaReform2025 = {
  "id": "rugby-bundesliga-reform-2025-26",
  "title": "Umfassende Reform der Rugby-Bundesliga: Neue Ära beginnt 2025/26",
  "slug": "rugby-bundesliga-reform-neue-aera-2025-26",
  "publishedAt": "2025-08-31T10:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "8 min",
  "tags": ["Rugby", "Bundesliga", "Reform", "Saison 2025/26", "Ligastruktur", "Nachwuchs", "U20"],
  "excerpt": "Mit Beginn der Saison 2025/26 wird die Rugby-Bundesliga umfassend reformiert. Eine eingleisige Liga mit zehn Teams, neues Scoring-Bonus-System und erstmals eine U20-Bundesliga markieren den Aufbruch in eine neue Ära.",
  "img": "/images/rugby-bundesliga-reform-2025-26.jpg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Mit Beginn der Saison 2025/26 wird die Rugby-Bundesliga umfassend reformiert. Bereits im Frühjahr 2025 wurde eine weitreichende Ligastruktur beschlossen, die eine Rückkehr zur eingleisigen Bundesliga mit zehn Teams vorsieht. Dieser Schritt soll die Leistungsdichte erhöhen, attraktive Duelle fördern und die Liga langfristig stärken."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Neue Struktur der 1. Bundesliga"
    },
    {
      "type": "paragraph",
      "content": "Die neue 1. Bundesliga wird im klassischen Hin- und Rückrundensystem gespielt, bevor das große Saisonfinale am 13. Juni den Meister kürt. Der Zehntplatzierte steigt direkt ab, der Neunte bestreitet die Relegation gegen den Finalverlierer der 2. Bundesliga."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Neuordnung der 2. Bundesliga"
    },
    {
      "type": "paragraph",
      "content": "Auch die zweite Liga wurde neu geordnet und in zwei regionale Gruppen, Südwest und Nordost, aufgeteilt. Während im Südwesten acht Teams antreten, startet die Nordost-Staffel aufgrund besonderer Umstände nur mit sieben Mannschaften. Kein Verein aus der Regionalliga konnte den Aufstieg realisieren, zudem zog der RC Dresden seine Meldung zurück."
    },
    {
      "type": "paragraph",
      "content": "Der Aufstieg wird in Playoffs ermittelt: Die beiden Gruppensieger treten in Halbfinals und einem Endspiel gegeneinander an. Der Gewinner steigt direkt in die Bundesliga auf, der Verlierer erhält die Chance in der Relegation. Der Abstieg aus der 2. Bundesliga richtet sich nach den Bewegungen zwischen erster und zweiter Liga. Grundsätzlich muss in jeder Staffel mindestens ein Platz für einen Regionalliga-Aufsteiger geschaffen werden. Im ungünstigsten Fall können dadurch bis zu drei Mannschaften absteigen."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Neues Scoring-Bonus-System für deutsche Talente"
    },
    {
      "type": "paragraph",
      "content": "Ein zentraler Bestandteil der Reform ist das neue Scoring-Bonus-System, das die Integration deutscher Talente sichern soll. Spieler ohne Spielberechtigung für die deutsche Nationalmannschaft werden mit zwei Punkten bewertet, Spieler mit Spielberechtigung für die deutsche Nationalmannschaft mit einem Punkt. Für in Deutschland ausgebildete Spieler werden null Punkte berechnet, für Eigengewächse sogar minus eins."
    },
    {
      "type": "paragraph",
      "content": "Der erlaubte Maximalwert für den Kader eines Bundesligaspiels liegt bei 20 Punkten. Dieser Wert wird bis 2030 sukzessive gesenkt, um sicherzustellen, dass die Zahl der eingesetzten Eigengewächse kontinuierlich steigt und die Nachwuchsarbeit in den Vereinen belohnt wird."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Sportliche Prognosen für die neue Saison"
    },
    {
      "type": "paragraph",
      "content": "Sportlich startet der amtierende Meister SC Frankfurt 1880 als klarer Favorit in die neue Saison. Als engste Verfolger gelten der SC Neuenheim, der TSV Handschuhsheim und Hannover 78. Außenseiterchancen werden dem Heidelberger RK und dem München RFC eingeräumt, die in den vergangenen Jahren deutliche Entwicklungsschritte gezeigt haben."
    },
    {
      "type": "paragraph",
      "content": "In der 2. Bundesliga zählen der RC Rottweil, der RK Heusenstamm, der Hamburger RC und Victoria Linden zu den ambitioniertesten Aufstiegskandidaten, während sich der RSV Köln und der RC Leipzig im Umbruch befinden, aber ebenfalls Einfluss auf den Wettbewerb nehmen können."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Mediale Standards für mehr Sichtbarkeit"
    },
    {
      "type": "paragraph",
      "content": "Um die Sichtbarkeit des Rugbysports in Deutschland zu erhöhen, wurden erstmals mediale Standards verpflichtend festgeschrieben. Alle Bundesligisten müssen Spiele per Liveticker begleiten und Aufzeichnungen bereitstellen. Soweit möglich, sollen die Begegnungen auf YouTube abrufbar sein. Ziel ist es, Reichweite und öffentliche Wahrnehmung nachhaltig zu steigern."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Premiere der U20-Bundesliga"
    },
    {
      "type": "paragraph",
      "content": "Darüber hinaus wurde erstmals eine U20-Bundesliga eingeführt. Drei Mannschaften – Berlin, Niedersachsen sowie eine Spielgemeinschaft Frankfurt/München – haben für die Premierensaison gemeldet. In sechs Begegnungen wird der erste deutsche U20-Meister ermittelt. Als zusätzliches Highlight ist ein Vorspiel im Rahmen des Bundesligafinales vorgesehen, in dem eine Auswahl der besten U20-Spieler gegen eine Einladungsmannschaft antritt."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Das große Finale im Juni"
    },
    {
      "type": "paragraph",
      "content": "Das Bundesligafinale im Juni soll als Gesamtveranstaltung durchgeführt werden. Neben der U20-Meisterschaft und dem Relegationsspiel wird das Endspiel um die Deutsche Meisterschaft den krönenden Abschluss bilden. Die Ausschreibung für die Austragung erfolgt im September, der Spielort wird mit Abschluss der Hinrunde bekanntgegeben."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Ein Meilenstein für den deutschen Rugby"
    },
    {
      "type": "paragraph",
      "content": "Mit diesen Maßnahmen wurde ein klares Signal für die Zukunft des deutschen Rugby gesetzt. Die Bundesliga wird sportlich dichter, medial sichtbarer und nachhaltiger aufgestellt. Die Saison 2025/26 verspricht damit zu einem Meilenstein in der Entwicklung des Rugbysports in Deutschland zu werden – auf und neben dem Spielfeld."
    },
    {
      "type": "footer",
      "content": "Artikel-Bild: © Herrmann Agenturfotografie"
    }
  ]
};
